import axiosApiClient, { axiosApiPublicClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/subscription";

class SubscriptionService {
  fetchSubscriptions = async () => {
    try {
      const response = await axiosApiPublicClient.get(`api${BASE_URL}/`);
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching subscriptions");
    }
  };

  getSubscriptionsCreditsHistory = async (page) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/history?page=${page}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching subscriptions credits history"
      );
    }
  };

  choosePlan = async (body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/assign`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while choosing subscription plan");
    }
  };

  rechargeCredits = async (amount, paymentMethod) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/recharge`, {
        amount,
        paymentMethod,
      });
      if (response.status !== 201) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while recharging.");
    }
  };
}

const subscriptionService = new SubscriptionService();

export default subscriptionService;
